export default "__VITE_ASSET__Bmu0CXZF__"